<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span style="font-size: 1.75rem; font-weight: 500; padding-top: 1rem;">
          {{ add ? 'เพิ่ม' : 'ลบ' }} Group categories
        </span>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="add-group-categories-form"
          @submit.prevent="onSubmit()">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedGroupCategories"
                :items="groupCategories"
                :search-input.sync="search"
                placeholder="เลือก Group categories"
                multiple
                outlined
                hide-details
                :loading="loading"
                class="mr-2">
                <template #prepend-inner>
                  <v-icon
                    small
                    style="margin-top: 3px;">
                    mdi-tag
                  </v-icon>
                </template>
                <template #selection>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-divider class="mb-6" />
              <span style="font-size: 1.25rem; font-weight: bold; color: black;">
                {{ formData.groupCategories.length ? 'Group categories ที่เลือก' : 'ยังไม่ได้เลือก Group categories' }}
              </span>
              <div class="group-categories-container mb-2">
                <v-chip
                  v-for="(selected, index) in formData.groupCategories"
                  :key="`selected-chip-${index}`"
                  class="ma-1"
                  color="teal"
                  text-color="white"
                  small
                  label
                  close
                  @click:close="unSelect(index)">
                  {{ selected }}
                </v-chip>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="d-flex justify-end align-center"
              style="gap: 0.5rem;">
              <v-btn
                color="error"
                text
                :disabled="loading"
                @click="closeForm()">
                ปิด
              </v-btn>
              <v-btn
                type="submit"
                color="success"
                text
                :disabled="loading || !formData.groupCategories.length">
                ยืนยัน
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AttributesAssignerProvider from '@/resources/AttributesAssignerProvider'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'

const AttributesAssignerService = new AttributesAssignerProvider()
const ProductAttributeService = new ProductAttributeProvider()

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: () => []
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      formData: {
        products: [],
        groupCategories: []
      },
      search: '',
      groupCategories: []
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    selectedGroupCategories: {
      get () {
        return this.formData.groupCategories
      },
      set (val) {
        this.formData.groupCategories = val
        // this.search = ''
      }
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        this.formData = {
          products: this.products,
          groupCategories: []
        }
        this.getAttributes()
      }
    }
  },
  methods: {
    async getAttributes () {
      try {
        this.loading = true

        if (this.add) {
          const { data } = await ProductAttributeService.getProductAttribute('group-categories', {
            page: 1,
            limit: 9999,
            sortBy: ['id'],
            sortDesc: [true]
          })

          this.groupCategories = data.results.map((item) => item.name)
        } else {
          const mapped = this.products.reduce((arr, p) => [...arr, ...p.groupCategories], [])
          this.groupCategories = [...new Set(mapped)]
        }
      } catch (error) {
        console.error('getAttributes', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async onSubmit () {
      try {
        this.loading = true
        this.$store.dispatch('Components/setLoading', {
          active: true,
          clickAble: false,
          message: 'PROCESSING...'
        })

        const valid = await this.$refs['add-group-categories-form'].validate()

        if (valid && this.add) {
          await AttributesAssignerService.addGroupCategories({
            products: this.formData.products.map((v) => v.id),
            groupCategories: this.formData.groupCategories
          })

          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Add Group categories success.',
            type: 'success'
          })
        } else if (valid) {
          await AttributesAssignerService.removeGroupCategories({
            products: this.formData.products.map((v) => v.id),
            groupCategories: this.formData.groupCategories
          })

          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Remove Group categories success.',
            type: 'success'
          })
        }

        this.closeForm()
        this.$emit('updated')
      } catch (error) {
        console.error('onSubmit', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
        this.$store.dispatch('Components/setLoading', { active: false })
      }
    },
    closeForm () {
      this.dialog = false
    },
    unSelect (index) {
      const itemIndex = this.groupCategories.findIndex((item) => item === this.formData.groupCategories[index])

      if (itemIndex !== -1) {
        this.formData.groupCategories.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>

</style>
